<template>
  <svg width="50" height="50" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect x="30" y="20" width="40" height="60" fill="gray" stroke="black" stroke-width="2"/>
    <rect x="40" y="30" width="10" height="10" fill="black"/>
    <rect x="50" y="30" width="10" height="10" fill="black"/>
    <rect x="40" y="50" width="10" height="10" fill="black"/>
    <rect x="50" y="50" width="10" height="10" fill="black"/>
  </svg>
</template>
